export default __webpack_public_path__ + "static/check-me-now-icon-aafb8139d39f64e65aee46a677c03066.png";